export default function IconWebsite() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M3.80952 6L7.73016 6.60759L13.4603 7.97468H15.119L16.0238 8.88608V10.4051L17.2302 9.64557V8.88608H18.1349V7.97468H19.3413L19.9444 6.60759H20.6984L21 7.67089L20.6984 8.43038V9.34177L19.3413 9.64557V10.4051L19.0397 12.9873L17.5317 14.5063V15.2658L18.4365 17.6962H17.2302L15.5 15.7215L14.5159 15.7215L14.0635 16.481H12.4048L11.1984 17.0886V18H10.5952L9.84127 16.0253H9.0873L8.63492 16.481L7.73016 14.8101H6.97619L6.52381 15.2658L3.20635 14.0506L2 11.3165V8.43038L2.60317 7.36709V6L3.20635 6.60759L3.80952 6Z"
                stroke="#707070"
                strokeLinejoin="round"
            />
        </svg>
    );
}
